module.exports = __webpack_public_path__ + "static/img/minicon1.e959e204.png";